export default __webpack_public_path__ + "static/media/logo-leclerc-header.5064b41d.svg";